import { useMutation, useQuery, useQueryClient } from 'react-query';

import { useServiceError } from '@/hooks';

import {
  CreatePartVehicleApplicationFreeRequest,
  CreatePartVehicleApplicationRequest,
} from './PartVehicleApplications.types';

import {
  listPartVehicleApplications,
  deletePartVehicleApplication,
  createPartVehicleApplication,
  listPartVehicleApplicationsFree,
  createPartVehicleApplicationFree,
  deletePartVehicleApplicationFree,
} from './PartVehicleApplications.service';
import { notification } from 'antd';
import { useIntl } from 'react-intl';

export function usePartVehicleApplicationsFree(partId?: number) {
  const query = useQuery(
    ['partApplicationsFree', partId],
    () => {
      return listPartVehicleApplicationsFree(partId);
    },
    {
      enabled: !!partId,
    },
  );

  useServiceError(query.error);

  return query;
}

export function useCreatePartVehicleApplicationFree() {
  const intl = useIntl();
  const queryClient = useQueryClient();
  const mutation = useMutation(
    (obj: CreatePartVehicleApplicationFreeRequest) =>
      createPartVehicleApplicationFree(obj),
    {
      onSuccess() {
        queryClient.invalidateQueries(['partApplicationsFree']);

        notification.success({
          message: intl.formatMessage({
            id: 'parts.application.modal.create.success.title',
          }),
          description: intl.formatMessage({
            id: 'parts.application.modal.create.success.description',
          }),
        });
      },
    },
  );

  useServiceError(mutation.error);

  return mutation;
}

export function useDeletePartVehicleApplicationFree() {
  const queryClient = useQueryClient();
  const intl = useIntl();
  const mutation = useMutation(
    (id: number) => deletePartVehicleApplicationFree(id),
    {
      onSuccess() {
        queryClient.invalidateQueries(['partApplicationsFree']);

        notification.success({
          message: intl.formatMessage({
            id: 'parts.application.modal.create.success.title',
          }),
          description: intl.formatMessage({
            id: 'parts.application.modal.remove.success.description',
          }),
        });
      },
    },
  );

  useServiceError(mutation.error);

  return mutation;
}

export function usePartVehicleApplications(partId?: number) {
  const query = useQuery(
    ['partApplications', partId],
    () => {
      return listPartVehicleApplications(partId);
    },
    {
      enabled: !!partId,
    },
  );

  useServiceError(query.error);

  return query;
}

export function useCreatePartVehicleApplication() {
  const intl = useIntl();
  const queryClient = useQueryClient();
  const mutation = useMutation(
    (obj: CreatePartVehicleApplicationRequest) =>
      createPartVehicleApplication(obj),
    {
      onSuccess() {
        queryClient.invalidateQueries(['partApplications']);

        notification.success({
          message: intl.formatMessage({
            id: 'parts.application.modal.create.success.title',
          }),
          description: intl.formatMessage({
            id: 'parts.application.modal.create.success.description',
          }),
        });
      },
    },
  );

  useServiceError(mutation.error);

  return mutation;
}

export function useDeletePartVehicleApplication() {
  const queryClient = useQueryClient();
  const intl = useIntl();
  const mutation = useMutation(
    (id: number) => deletePartVehicleApplication(id),
    {
      onSuccess() {
        queryClient.invalidateQueries(['partApplications']);

        notification.success({
          message: intl.formatMessage({
            id: 'parts.application.modal.create.success.title',
          }),
          description: intl.formatMessage({
            id: 'parts.application.modal.remove.success.description',
          }),
        });
      },
    },
  );

  useServiceError(mutation.error);

  return mutation;
}
